import { withStyles } from '@material-ui/core'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withErrorCatcher from '../../../components/Common/withErrorCatcher'
import { Textures } from './Textures'
import { Header } from './Header'
import { Step1 } from './Step1'
import { Step2, getAPICompanySize } from './Step2'
import { Step3 } from './Step3'
import { Step4 } from './Step4'
import { Step5 } from './Step5'
import { withAuth0 } from '@auth0/auth0-react'
import { loadOrganizationData } from '../../../../utils/loadOrganizationData'
import { persistor } from '../../../..'
import { cbContinueSignUp } from '../../../../TuqqiRouting'
import i18n from '../../../../i18n'
import { getTuqqiLangLocaleBased } from '../../../../utils/dateFnsLocale'
import { StepExistsError } from './StepExistsEror'

export const STEP_ONE = "step1";
export const STEP_TWO = "step2";
export const STEP_THREE = "step3";
export const STEP_FOUR = "step4";
export const STEP_FIVE = "step5";

const styles = theme => ({
    container: {
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh',
        // background: '#FFFFFF',
        background: "radial-gradient(92.95% 100% at 50% 100%, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.2) 100%)",
        overflow: 'hidden',
        position: 'relative',
    },
    textures: {
        zIndex: 0,
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    }
})
const sleep = ms => new Promise(r => setTimeout(r, ms));

const removeSpaces = (str) => {
    return str
        .split('')
        .filter(x => x !== '')
        .map(x => x.trim())
        .join('')
        .toLocaleLowerCase()
}

const _OrgSetup = (props) => {
    const {  classes, auth0, dispatch, signupService, userSettingsService, adminService } = props
    const [step, setStep] = useState(1)
    const [name, setName] = useState("")
    const [orgName, setOrgName] = useState("")
    // const [templateName, setTemplateName ] = useState("SaaS")
    const [isThirdPartyLogin, setIsThirdPartyLogin] = useState(false);
    const [user, setUser] = useState(null);
    const [errorExists, setErrorExists] = useState(false);
    const [userLang, setUserLang] = useState(getTuqqiLangLocaleBased());
    const [role, setRole] = useState('Owner');
    const [industry, setIndustry] = useState('Retail');
    const [companySize, setCompanySize] = useState('1-10');

    const userRef = useRef(user)

    useEffect(() => {
        userRef.current = user
    }, [user])

    useEffect(() => {
        const l = getTuqqiLangLocaleBased()
        setUserLang(l)
        i18n.changeLanguage(l)
    }, [])

    const onNext = () => {
        setStep(prev => prev + 1)

    }
    const onPrev = () => setStep(prev => prev - 1)

    const checkUserMissing = async () => {
        try {
            if(!!userRef.current.auth0_id && !userRef.current.tag) {
                const [_firstName, ..._secondName] = name.split(" ")
                const firstName = _firstName.trim();
                const lastName = _secondName.join("").trim();
                const tag = `${removeSpaces(firstName)}${removeSpaces(lastName)}`.replace(/[^a-z0-9]+/gi, "").toLocaleLowerCase()
                const newData = {
                    birthday: "",
                    firstname: firstName,
                    lastname: lastName,
                    role: 'Admin',
                    lang: userLang,
                    tag
                }
                await userSettingsService.editUserSetting(newData)
                return true
            } else {
                return false
            }
        } catch (error) {
            return false
        }
    }

    const onEnterSystem = async () => {
        try {
        const claims = await auth0.getIdTokenClaims();

            await checkUserMissing()
            await loadOrganizationData(claims.__raw, dispatch, {preventlog: 1})
            await sleep(500)
            await persistor.persist()
            const userrr = await userSettingsService.getUser();
            await sleep(200)
            // await window.location.reload();
            cbContinueSignUp.value(userrr)
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        const fetchData = async () => {

            const idToken = await auth0.getIdTokenClaims();
            
            const { given_name = '', family_name = '' } = idToken ?? {};
            
            const isGoogleLogin = idToken?.sub?.includes('google');
            const isMicrosoftLogin = idToken?.sub?.includes('live');
            const isFacebookLogin = idToken?.sub?.includes('facebook');
            const isLinkedInLogin = idToken?.sub?.includes('linkedin');
            userSettingsService.getUser().then(user => {
                setUser(user);
            })
            if(!isGoogleLogin && !isMicrosoftLogin && !isFacebookLogin && !isLinkedInLogin) return
            setIsThirdPartyLogin(true);

            setName(`${given_name} ${family_name}`);
        };
        fetchData();
    }, []);

    const signupSteps = useCallback(async () => {
        try {
        if (!userRef.current.org) { await signupService.createOrganizationStep1({ title: orgName, templateName: industry, companySize: getAPICompanySize(companySize), role }); }
        if (!userRef.current.org || userRef.current.org.templateName === STEP_TWO) { await signupService.createOrganizationStep2(); }
        if (!userRef.current.org || userRef.current.org.templateName === STEP_THREE) { await signupService.createOrganizationStep3(); }
        if (!userRef.current.org || userRef.current.org.templateName === STEP_FOUR) { await signupService.createOrganizationStep4(); }

        await signupService.createOrganizationStep5();

        setStep(5)
        } catch (error) {
            console.log({error});
                        
        }
    }, [orgName, industry, companySize, role])

    useEffect(() => {
        if(step !== 4) return
        if(userRef.current?.status === 'USER_NOT_FOUND') {
            const [_firstName, ..._secondName] = name.split(" ")
            const firstName = _firstName.trim();
            const lastName = _secondName.join("").trim();
            // start registration                    
            adminService.createAdminSignUp( firstName, lastName, userLang).then((response) => {
                console.log('vfvfdffvfv', response);
                
                if(response?.status === 'User already exists') {
                    setErrorExists(true)
                    return
                }
                signupSteps()
            });
        } else {
            signupSteps();
        }       
        
    }, [step, userLang, name, signupSteps])

    const renderStep = () => {
        if(errorExists) return <StepExistsError />
        switch (step) {
            case 1:
                return <Step1 userLang={userLang} setUserLang={setUserLang} isThirdPartyLogin={isThirdPartyLogin} name={name} setName={setName} role={role} setRole={setRole} allowNext={!!name.trim()} onNext={onNext} />
            case 2:
                return <Step2 industry={industry} setIndustry={setIndustry} companySize={companySize} setCompanySize={setCompanySize} orgName={orgName} setOrgName={setOrgName} allowNext={!!orgName.trim()} onNext={onNext} onPrev={onPrev} />
            case 3:
                return <Step3  orgName={orgName} allowNext={!!industry.trim()} onNext={onNext} onPrev={onPrev} />
            case 4:
                return <Step4 templateName={industry} userName={name} orgName={orgName} />
            case 5:
                return <Step5 onEnterSystem={onEnterSystem} />
        
            default:
                return null
        }
    }
    return <div className={classes.container}>
        <Header step={step} />
        {renderStep()}
        <div className={classes.textures} style={{background: `var(--custom-sharp-01, url(${require("../../../../assets/img/signup_bg.png")}) transparent 50% / cover no-repeat)`}} id={"TEXTURES_ids"}>
            {/* <Textures /> */}
        </div>
    </div>
}

const mapStateToProps = (state, ownProps) => ({
    routerLocation: ownProps.location,
    authService: state.authModule.authService,
    idToken: state.userData.idToken,
    ...state.services
})

const mapDispatchToProps = (dispatch) => ({ dispatch })


export const OrgSetup = compose(
    withAuth0,
    withStyles(styles, { withTheme: true }),   
    connect(mapStateToProps, mapDispatchToProps),
    withErrorCatcher("Failed loading user, Please Contact Tuqqi Support")
)(_OrgSetup)